import React from "react";
import "./Sidebar.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TuneIcon from "@mui/icons-material/Tune";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { CSSTransition } from "react-transition-group";
import Groups2Icon from "@mui/icons-material/Groups2";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ApiConfig from "../../common/config/ApiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLanguage } from "../../common/i18n/LanguageContext";

function Sidebar({ pos }) {
  // console.log(pos)
  const { t } = useLanguage();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(
    location.pathname.startsWith("/agent"),
  );
  const [position, setPosition] = useState(pos);
  const user = localStorage.getItem("user");

  const useprofitdetail = () => {
    ApiConfig.get(`/agentprofile?user=${encodeURIComponent(user)}`).then(
      (result) => {
        if (result.resCode === 200) {
          setPosition(result.data.position);
        } else {
          toast.error(result.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      },
    );
  };

  useEffect(() => {
    useprofitdetail();
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/agent")) {
      setIsSubMenuOpen(true);
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  const menuItems = [
    {
      category: t("menu_category_1"),
      items: [
        {
          icon: <DashboardIcon />,
          label: `1.1 ${t("menu_dashboard")}`,
          href: "/",
        },
        {
          icon: <ManageAccountsIcon />,
          label: `1.2 ${t("menu_manage_members")}`,
          href: "/member",
        },
        {
          icon: <ManageAccountsIcon />,
          label: `1.3 ${t("menu_manage_subaccount")}`,
          href: "/subaccount",
        },
        ...(position !== "agent"
          ? [
              {
                icon: <Groups2Icon />,
                label: `1.4 ${t("menu_agent_system")}`,
                submenu: [
                  // Add submenu items based on user's roxale (pos)
                  ...(position === "owner"
                    ? [
                        // {
                        //   label: `1.4.1 ${t("menu_manage_company")}`,
                        //   href: "/agent?level=company",
                        // },
                        {
                          label: `1.4.2 ${t("menu_manage_senior")}`,
                          href: "/agent?level=senior",
                        },
                        {
                          label: `1.4.3 ${t("menu_manage_master")}`,
                          href: "/agent?level=master",
                        },
                        {
                          label: `1.4.4 ${t("menu_manage_agent")}`,
                          href: "/agent?level=agent",
                        },
                      ]
                    : []),
                  ...(position === "company"
                    ? [
                        {
                          label: `1.4.1 ${t("menu_manage_senior")}`,
                          href: "/agent?level=senior",
                        },
                        {
                          label: `1.4.2 ${t("menu_manage_master")}`,
                          href: "/agent?level=master",
                        },
                        {
                          label: `1.4.3 ${t("menu_manage_agent")}`,
                          href: "/agent?level=agent",
                        },
                      ]
                    : []),
                  ...(position === "senior"
                    ? [
                        {
                          label: `1.4.1 ${t("menu_manage_master")}`,
                          href: "/agent?level=master",
                        },
                        {
                          label: `1.4.2 ${t("menu_manage_agent")}`,
                          href: "/agent?level=agent",
                        },
                      ]
                    : []),
                  ...(position === "master"
                    ? [
                        {
                          label: `1.4.1 ${t("menu_manage_agent")}`,
                          href: "/agent?level=agent",
                        },
                      ]
                    : []),
                ],
                isOpen: isSubMenuOpen,
                toggleSubMenu: toggleSubMenu,
              },
              {
                icon: <ManageAccountsIcon />,
                label: `1.5 ${t("menu_manage_commission")}`,
                href: "/commission",
              },
            ]
          : []),
        {
          icon: <ManageAccountsIcon />,
          label: `1.6 ${t("menu_manage_topup")}`,
          href: "/member-top-up",
        },
        {
          icon: <ManageAccountsIcon />,
          label: `1.7 ${t("menu_manage_withdraw")}`,
          href: "/member-withdraw",
        },
      ].filter(Boolean),
    },
    {
      category: t("menu_category_2"),
      items: [
        ...(position === "owner"
          ? [
              {
                icon: <TuneIcon />,
                label: `2.1 ${t("menu_lotto_onoff")}`,
                href: "/lotto-service",
              },
            ]
          : []),
        {
          icon: <TuneIcon />,
          label: `2.2 ${t("menu_limit_number")}`,
          href: "/limitnumber",
        },
        {
          icon: <TuneIcon />,
          label: `2.3 ${t("menu_max_fight")}`,
          href: "/Fightlimitmax",
        },
        ...(position === "owner"
          ? [
              {
                icon: <TuneIcon />,
                label: `2.4 ${t("menu_commission_reward_setting")}`,
                href: "/setting/commission-reward",
              },
              {
                icon: <TuneIcon />,
                label: `2.5 ${t("menu_lotto_type_setting")}`,
                href: "/setting/lotto-type",
              },
              {
                icon: <TuneIcon />,
                label: `2.6 ${t("menu_schedule_setting")}`,
                href: "/setting/schedule",
              },
            ]
          : []),
      ],
    },
    {
      category: t("menu_category_3"),
      items: [
        {
          icon: <ReceiptIcon />,
          label: `3.1 ${t("menu_winlose")}`,
          href: "/winlose",
        },
        {
          icon: <ReceiptIcon />,
          label: `3.2 ${t("menu_lotto_result")}`,
          href: "/lottoresult",
        },
        {
          icon: <ReceiptIcon />,
          label: `3.3 ${t("menu_membertopup_report")}`,
          href: "/membertopup-report",
        },
        {
          icon: <ReceiptIcon />,
          label: `3.4 ${t("menu_agenttopup_report")}`,
          href: "/agenttopup-report",
        },
        // {
        //   icon: <ReceiptIcon />,
        //   label: "3.5 ยอดคงค้าง",
        //   href: "/lottowaitresult",
        // },
      ],
    },
    {
      category: t("menu_category_4"),
      items: [
        {
          icon: <ReceiptIcon />,
          label: `4.1 ${t("menu_outstanding_user")}`,
          href: "/lottowaitresultuser",
        },
        {
          icon: <ReceiptIcon />,
          label: `4.2 ${t("menu_outstanding_type")}`,
          href: "/lottowaitresulttype",
        },
        {
          icon: <ReceiptIcon />,
          label: `4.3 ${t("menu_bet_amount")}`,
          href: "/lottobet",
        },
      ],
    },
    {
      category: t("menu_category_5"),
      items: [
        {
          icon: <ReceiptIcon />,
          label: `5.1 ${t("menu_login_history")}`,
          href: "/loginlogs",
        },
        {
          icon: <ReceiptIcon />,
          label: `5.2 ${t("menu_activity_logs")}`,
          href: "/activitylog",
        },
        {
          icon: <TuneIcon />,
          label: `5.3 ${t("menu_settings")}`,
          href: "/settings",
        },
      ],
    },
  ];

  return (
    <div className="relative">
      <button
        className="fixed bottom-0 left-0 p-2 m-2 rounded-pill bg-brand-blue-700 text-white text-xs font-heading font-semibold hover:bg-brand-blue-600 shadow-card"
        onClick={toggleSidebar}
      >
        {isOpen ? t("sidebar_close_menu") : t("sidebar_open_menu")}
      </button>
      <CSSTransition
        in={isOpen}
        timeout={300}
        classNames="sidebar"
        unmountOnExit
      >
        <div className="w-auto h-full flex flex-col bg-white w-60 font-body shadow-cardLight">
          <div className="sidebar-clock bg-gradient-to-b from-brand-blue-700 to-brand-blue-900 text-center rounded-b-lg p-1.5 border-b-2 border-brand-gold-300">
            <span className="text-brand-gold-200 text-xs font-bold font-heading">
              {currentTime.toLocaleString("en-US", {
                weekday: "short",
                day: "numeric",
                month: "short",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
              })}
            </span>
          </div>
          <div className="menu p-1">
            {menuItems.map((category) => (
              <div key={category.category}>
                <div className="rounded-lg bg-brand-blue-900 h-[1.5em] p-1 mt-1">
                  <h4 className="text-brand-gold-300 text-xs font-extrabold font-heading ml-2">
                    {category.category}
                  </h4>
                </div>

                {category.items.map((menuItem) =>
                  menuItem.submenu ? (
                    <div className="flex flex-col" key={menuItem.label}>
                      <div
                        className={`link mt-1 ${menuItem.isOpen ? "active" : ""} hover:bg-brand-blue-100 rounded-t-lg`}
                        onClick={menuItem.toggleSubMenu}
                      >
                        <span className="text-brand-blue-700">
                          {menuItem.icon}
                        </span>
                        <span className="ml-2 mt-1 text-xs font-light text-zinc-700 hover:text-brand-blue-800">
                          {menuItem.label}
                        </span>
                        {menuItem.isOpen ? (
                          <ExpandLessIcon className="ml-2 mt-1 text-xs font-light text-zinc-700 hover:text-brand-blue-800" />
                        ) : (
                          <ExpandMoreIcon className="ml-2 mt-1 text-xs font-light text-zinc-700 hover:text-brand-blue-800" />
                        )}
                      </div>
                      <CSSTransition
                        in={menuItem.isOpen}
                        timeout={300}
                        classNames="submenu"
                        unmountOnExit
                      >
                        <div className="pl-4">
                          {menuItem.submenu.map((subMenuItem) => (
                            <a
                              href={subMenuItem.href}
                              className={`link mt-1 ${
                                new URLSearchParams(location.search).get(
                                  "level",
                                ) ===
                                new URLSearchParams(
                                  subMenuItem.href.split("?")[1] ?? "",
                                ).get("level")
                                  ? "active"
                                  : ""
                              } hover:bg-brand-blue-100 rounded-t-lg`}
                              key={subMenuItem.href}
                            >
                              <span className="ml-2 mt-1 text-xs font-light text-zinc-700 hover:text-brand-blue-800">
                                {subMenuItem.label}
                              </span>
                            </a>
                          ))}
                        </div>
                      </CSSTransition>
                    </div>
                  ) : (
                    <div className="flex flex-col" key={menuItem.href}>
                      <Link to={menuItem.href}>
                        <div
                          className={`link mt-1 ${
                            location.pathname === menuItem.href ? "active" : ""
                          } hover:bg-brand-blue-100 rounded-t-lg`}
                        >
                          <span className="text-brand-blue-700">
                            {menuItem.icon}
                          </span>
                          <span className="ml-2 mt-1 text-xs font-light text-zinc-700 hover:text-brand-blue-800">
                            {menuItem.label}
                          </span>
                        </div>
                      </Link>
                      <div className="p-1">
                        <div className="w-full h-[1px] bg-zinc-200"></div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            ))}
          </div>
        </div>
      </CSSTransition>
    </div>
  );
}

export default Sidebar;
